module.exports = require("remark-strip-badges");


//////////////////
// WEBPACK FOOTER
// external "remark-strip-badges"
// module id = 62
// module chunks = 0 1 2 3 4 5 6 7 8 9 12 13